import React from 'react';
import { FileExcelOutlined, FileOutlined, FilePdfOutlined, FilePptOutlined, FileWordOutlined, PlayCircleOutlined } from '@ant-design/icons';
import type { WebsiteMediaItem } from '../graphql/types';
import { fileExtension } from './mediaFormat';

const DOCUMENT_ICONS: Record<string, React.ReactNode> = {
    pdf: <FilePdfOutlined className="text-red-500" />,
    doc: <FileWordOutlined className="text-blue-600" />,
    docx: <FileWordOutlined className="text-blue-600" />,
    xls: <FileExcelOutlined className="text-green-600" />,
    xlsx: <FileExcelOutlined className="text-green-600" />,
    ppt: <FilePptOutlined className="text-orange-500" />,
    pptx: <FilePptOutlined className="text-orange-500" />,
};

/** 媒体缩略图：图片用 640 宽版本，视频取首帧（只加载元数据），文档按扩展名显示图标 */
const MediaThumb: React.FC<{ item: WebsiteMediaItem; className?: string }> = ({ item, className = '' }) => {
    if (item.mediaType === 'IMAGE') {
        return (
            <img
                src={item.thumbnailUrl ?? item.url}
                alt={item.fileName}
                loading="lazy"
                className={`w-full h-full object-cover ${className}`}
            />
        );
    }
    if (item.mediaType === 'VIDEO') {
        return (
            <div className={`relative w-full h-full bg-black ${className}`}>
                <video src={item.url} preload="metadata" muted className="w-full h-full object-cover" />
                <PlayCircleOutlined className="absolute inset-0 m-auto text-3xl text-white/80 w-fit h-fit" />
            </div>
        );
    }
    return (
        <div className={`w-full h-full flex flex-col items-center justify-center bg-gray-50 text-4xl ${className}`}>
            {DOCUMENT_ICONS[fileExtension(item.fileName)] ?? <FileOutlined className="text-gray-400" />}
            <span className="text-xs text-gray-400 mt-1 uppercase">{fileExtension(item.fileName)}</span>
        </div>
    );
};

export default MediaThumb;
